import apiClient from '../../../../../../services/apiClient';
import { ageRanges } from '../../../../../adminDOU/components/Statistica/StatisticaQueueKg/constants/queueConstants';



export async function getRequestsAdvanced(params, isMy = false) {
    const {
        search = '',
        page = 0,
        pageSize = 10,
        sortBy = 'submitted',
        sortDirection = 'desc',
        // Расширенные фильтры
        ageFrom,
        ageTo,
        genders,
        benefitTypes,
        onlyApprovedBenefits,
        dissabilityTypes,
        placeTypes,
        createdFrom,
        createdTo,
        preferDateFrom,
        preferDateTo,
        inviteDateFrom,
        inviteDateTo,
        statuses,
        hasInvite,
        hasDeclinedInvite,
        hasSelectedKindergartens,
        districts,
        selectedKindergartens,
        ageRanges,
        inviteStatuses,
        inviteKindergartens,
    } = params;

    const requestBody = {
        search,
        page,
        pageSize,
        sortBy: mapSortField(sortBy),
        sortDirection
    };

    // Добавляем только непустые фильтры
    if (ageFrom) requestBody.ageFrom = parseInt(ageFrom);
    if (ageTo) requestBody.ageTo = parseInt(ageTo);
    if (ageRanges) requestBody.ageRanges = ageRanges;
    if (genders?.length) requestBody.genders = genders;
    if (benefitTypes?.length) requestBody.benefitTypes = benefitTypes;
    if (onlyApprovedBenefits) requestBody.onlyApprovedBenefits = true;
    if (dissabilityTypes?.length) requestBody.dissabilityTypes = dissabilityTypes;
    if (placeTypes?.length) requestBody.placeTypes = placeTypes;
    if (createdFrom) requestBody.createdFrom = createdFrom;
    if (createdTo) requestBody.createdTo = createdTo;
    if (preferDateFrom) requestBody.preferDateFrom = preferDateFrom;
    if (preferDateTo) requestBody.preferDateTo = preferDateTo;
    if (inviteDateFrom) requestBody.inviteDateFrom = inviteDateFrom;
    if (inviteDateTo) requestBody.inviteDateTo = inviteDateTo;
    if (statuses?.length) requestBody.statuses = statuses;
    if (hasInvite) requestBody.hasInvite = true;
    if (hasDeclinedInvite) requestBody.hasDeclinedInvite = true;
    if (hasSelectedKindergartens) requestBody.hasSelectedKindergartens = true;
    if (districts?.length) requestBody.districts = districts;
    if (selectedKindergartens?.length) requestBody.selectedKindergartens = selectedKindergartens;
    if (inviteStatuses?.length) requestBody.inviteStatuses = inviteStatuses;
    if (inviteKindergartens?.length) requestBody.inviteKindergartens = inviteKindergartens;

    const url = `get_requests_advanced${isMy ? '?as_priv=true' : ''}`;
    const response = await apiClient.post(url, requestBody);
    
    return {
        all_count: response.data.all_count,
        data: response.data.data
    };
}

function mapSortField(frontendField) {
    const mapping = {
        'name': 'child.lastName',
        'certificate': 'child.birthCertificate.number',
        'submitted': 'createdAt',
        'sendFrom': 'preferDateFrom',
        'statusText': 'currentStatus.name',
        'benefitText': 'child.benefits.benefitId',
        'preferDate': 'preferDateFrom',
        'inviteDate': 'invite.inviteDate',
        'declineCount': 'invite.inviteDecliningAmount',
        'age': 'child.birthDate'
    };
    return mapping[frontendField] || frontendField;
}